<template>
  <div :class="['plan-row-item-info-pill', left && 'plan-row-item-info-pill--left']">
    <div class="plan-row-item-info-pill__label">{{ info.label }}</div>
    <div class="plan-row-item-info-pill__separator" />
    <div class="plan-row-item-info-pill__text">{{ info.text }}</div>
  </div>
</template>

<script>
export default {
  name: 'PlanRowItemInfoPill',
  props: {
    info: {
      type: Object,
      required: true,
    },
    left: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item-info-pill {
  width: 100%;
  display: flex;
  font-size: 11px;
  justify-content: center;
  align-items: center;

  @include mobile {
    font-size: 12px;
  }

  &--left {
    justify-content: flex-start;
  }
  &__label {
    text-transform: uppercase;
    border-radius: 30px 0px 0px 30px;
    background: var(--strong-light-green);
    color: var(--gray-3);
    padding: 4px 4px 4px 10px;
    text-align: center;
  }
  &__separator {
    height: 21px;
    background: var(--strong-light-green);
    width: 8px;
    transform: skew(-16deg) translateX(-3px);
    @include mobile {
      height: 22px;
    }
  }
  &__text {
    background: var(--purple-gradient);
    border-radius: 0px 30px 30px 0px;
    font-family: var(--font-regular);
    color: var(--white);
    padding: 4px 10px;
    text-align: center;
    margin-left: -6px;
  }
}
</style>
